import { render, staticRenderFns } from "./ratings.judging.vue?vue&type=template&id=01682adc&scoped=true&"
import script from "./ratings.judging.vue?vue&type=script&lang=js&"
export * from "./ratings.judging.vue?vue&type=script&lang=js&"
import style0 from "./ratings.judging.vue?vue&type=style&index=0&id=01682adc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01682adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
